import { ToastContainer } from "react-toastify";

export default function Toast() {

    return (
        <ToastContainer
            className="toast-popup"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
    )
}